import { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import {
  login,
  requestOtp,
  setErrors,
  errorsSelector,
  sendingFormSelector,
  otpSelector,
} from '@src/features/customers/auth/store/auth';
import { AUTH_MODE, canResendCode } from '@src/domains/customers';
import useCountdownTimer from '@src/hooks/useCountdownTimer';

// Error context key for login actions in the store (state.auth.errors.login).
const LOGIN_CONTEXT = AUTH_MODE.LOGIN;
const IDLE_OTP_EXPIRY = new Date(0);

export function useLogin() {
  const dispatch = useAppDispatch();
  const errors = useAppSelector(errorsSelector)[LOGIN_CONTEXT];
  const loading = useAppSelector(sendingFormSelector);
  const { requestLockedUntil } = useAppSelector(otpSelector);

  const expiryDate = useMemo(
    () => (requestLockedUntil ? new Date(requestLockedUntil) : IDLE_OTP_EXPIRY),
    [requestLockedUntil],
  );
  const { minutes, seconds } = useCountdownTimer(expiryDate);
  const canResendOtp = canResendCode(requestLockedUntil);

  const submitPassword = (email: string, password: string) => dispatch(login({ email, password }));
  const submitOtp = (email: string, otp: string) => dispatch(login({ email, otp }));
  const sendOtp = (email: string) => dispatch(requestOtp({ email }));
  const clearErrors = () => dispatch(setErrors(LOGIN_CONTEXT, {}));

  return {
    submitPassword,
    submitOtp,
    sendOtp,
    clearErrors,
    errors,
    loading,
    otpResend: { minutes, seconds, canResend: canResendOtp },
  };
}
